import script from "./DashboardWorkloads.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardWorkloads.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardWorkloads.vue?vue&type=style&index=0&id=33cd8e92&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33cd8e92"]])

export default __exports__